const commonConfig = {

    adminStatus: {
        ACTIVE: 1,
        LOCKED: 2,
        BLOCKED: 3,
        DORMANT: 4,
        properties: {
            1: { name: "ACTIVE", value: 1, color: "success" },
            2: { name: "LOCKED", value: 2, color: "warning" },
            3: { name: "BLOCKED", value: 3, color: "danger" },
            4: { name: "DORMANT", value: 4, color: "primary" }
        }
    },
    userStatus: {
        ACTIVE: 1,
        LOCKED: 2,
        BLOCKED: 3,
        DISABLED: 4,
        properties: {
            1: { name: "ACTIVE", value: 1, color: "success" },
            2: { name: "LOCKED", value: 2, color: "warning" },
            3: { name: "BLOCKED", value: 3, color: "danger" },
            4: { name: "DISABLED", value: 4, color: "primary" }
        }
    },
    deviceStatus: {
        DEACTIVATED: 0,
        ACTIVATED: 1,
        BLOCKED: 2,
        BROKEN: 3,
        properties: {
            0: { name: "DEACTIVATED", value: 0, color: "primary" },
            1: { name: "ACTIVATED", value: 1, color: "success" },
            2: { name: "BLOCKED", value: 2, color: "danger" },
            3: { name: "BROKEN", value: 3, color: "warning" }
        }
    },
    serviceStatus: {
        OUT_OF_SERVICE: 0,
        IN_SERVICE: 1,
        properties: {
            0: { name: "OUT_OF_SERVICE", value: 0, color: "primary" },
            1: { name: "IN_SERVICE", value: 1, color: "success" }
        }
    },
    usedSubscriptionStatus: {
        NOT_USED_SUBSCRIBE: 0,
        USED_SUBSCRIBE: 1,
        USING_SUBSCRIBE: 2,
        properties: {
            0: { name: "NOT_USED_SUBSCRIBE", value: 0, color: "primary" },
            1: { name: "USED_SUBSCRIBE", value: 1, color: "success" },
            2: { name: "USING_SUBSCRIBE", value: 2, color: "warning" }
        }
    },
    inAppBillingStatus: {
        NORMAL: 1,
        NO_PAYMENT: 2,
        properties: {
            1: { name: "NORMAL", value: 1, color: "primary" },
            2: { name: "NO_PAYMENT", value: 2, color: "danger" }
        }
    },
    subscriptionCode: {
        MONTHLY: 1,
        properties: {
            1: { name: "MONTHLY", value: 1, color: "success" },
        }
    },
    uploaderCode: {
        DEVICE: 1,
        USER: 2,
        properties: {
            1: { name: "UPLOADER_DEVICE", value: 1, color: "primary" },
            2: { name: "UPLOADER_USER", value: 2, color: "success" }
        }
    },
    deviceChannelCode: {
        FRONT: 1,
        CABIN: 2,
        properties: {
            1: { name: "FRONT", value: 1, color: "primary" },
            2: { name: "CABIN", value: 2, color: "success" }
        }
    },
    storeType: {
        GOOGLE: 1,
        APPLE: 2,
        properties: {
            1: { name: "GOOGLE", value: 1, color: "primary" },
            2: { name: "APPLE", value: 2, color: "success" }
        }
    },
    paymentStatus: {
        ORDER_REQUEST: 1,
        VERIFY_A_PURCHASE: 2,
        PURCHASE_SUCCESS: 3,
        FAILED_VERIFY: 4,
        FAILED_PURCHASE: 5,
        SUB_CANCELED: 6,
        SUB_EXPIRED: 7,
        REVOKED: 8,
        properties: {
            1: { name: "ORDER_REQUEST", value: 1, color: "primary" },
            2: { name: "VERIFY_A_PURCHASE", value: 2, color: "primary" },
            3: { name: "PURCHASE_SUCCESS", value: 3, color: "success" },
            4: { name: "FAILED_VERIFY", value: 4, color: "danger" },
            5: { name: "FAILED_PURCHASE", value: 5, color: "danger" },
            6: { name: "SUB_CANCELED", value: 6, color: "warning" },
            7: { name: "SUB_EXPIRED", value: 7, color: "warning" },
            8: { name: "REVOKED", value: 8, color: "danger" },
        }
    },
    reqStatus: {
        DOWNLOAD_REQUEST: 1,
        DOWNLOAD_COMPLETE: 2,
        DOWNLOAD_ROLLBACK: 3,
        properties: {
            1: { name: "DOWNLOAD_REQUEST", value: 1, color: "primary" },
            2: { name: "DOWNLOAD_COMPLETE", value: 2, color: "success" },
            3: { name: "DOWNLOAD_ROLLBACK", value: 3, color: "warning" }
        }
    },
    serverMonitoring: {
        BACKOFFICE: 1,
        MOBILE_API: 2,
        PROVISIONING: 3,
        FILE_UPLOAD: 4,
        WOWZA: 5,
        MQTT: 6,
        properties: {
            1: { name: "BACKOFFICE", value: 1, color: "primary" },
            2: { name: "MOBILE_API", value: 2, color: "success" },
            3: { name: "PROVISIONING", value: 3, color: "warning" },
            4: { name: "FILE_UPLOAD", value: 4, color: "danger" },
            5: { name: "WOWZA", value: 5, color: "success" },
            6: { name: "MQTT", value: 6, color: "warning" }
        }
    },
    sendStatus: {
        RESERVED: 1,
        SENDING: 2,
        SEND_COMPLETE: 3,
        CANCEL_SEND: 4,
        properties: {
            1: { name: "RESERVED", value: 1, color: "primary" },
            2: { name: "SENDING", value: 2, color: "danger" },
            3: { name: "SEND_COMPLETE", value: 3, color: "success" },
            4: { name: "CANCEL_SEND", value: 4, color: "warning"}
        }
    },
    sendTarget: {
        ALL_MEMBER: 1,
        MEMBER: 2,
        NONMEMBER: 3,
        properties: {
            1: { name: "ALL_MEMBER", value: 1, color: "success" },
            2: { name: "MEMBER", value: 2, color: "primary" },
            3: { name: "NONMEMBER", value: 3, color: "warning" }
        }
    },
    sendResult: {
        NULL: 0,
        SUCCESS: 1,
        ERROR: 2,
        properties: {
            0: { name: "", value: 0, color: "default" },
            1: { name: "SUCCESS", value: 1, color: "success" },
            2: { name: "ERROR", value: 2, color: "danger" }
        }
    },
}


export default commonConfig